import React, { Component } from "react";
import { Input } from "components";
import { withRedux } from "helpers";
import {
  Form,
  FlexRow,
  BottomHintText,
  H1,
  H2,
  columnFlex,
  Button,
} from "appStyles";
import {
  SaveProgress,
  SelectOptions,
  RadioOptions,
  QRCodeGenerator,
  HintModal,
} from "components";
import EditBackground from "../EditBackground";
import { redemptionTypeOptions2 } from "constants";
import { css } from "react-emotion";
import NumberFormat from "react-number-format";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  padding: 20px;
  position: relative;
  padding: 1em;
  border-radius: 5px;
  margin-bottom: 3em;
  margin-top: 1em;
`;

const inputStyle = css`
  width: 100%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  margin-bottom: 10px;
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

const pointsConversionArray = () => {
  const result = [];

  for (let i = 100; i <= 2000; i += 100) {
    result.push({
      value: i,
      label: `${i} Pts`,
    });
  }

  return result;
};

class RewardsSettings extends Component {
  state = {
    croppingAspectRatio: "1.0",
  };
  update = (field) => (value) => {
    if (
      field === "dollarsToDollarCashCreditConversion" ||
      field === "minimumCashRequired"
    ) {
      if (value === null) {
        value = null;
      } else {
        // console.log("parsing value ");
        value = parseInt(value["value"]);
      }
    }
    // console.log(typeof value);
    this.props.actions.updateApplication(field, value);
  };
  updateComponent = (component) => {
    const { activeTemplate } = this.props;
    const updatedTemplate = {
      ...this.props.activeTemplate,
    };
    updatedTemplate.components = activeTemplate.components.map((c) =>
      c.componentNumber === component.componentNumber ? component : c
    );
    this.props.actions.updateTemplate(updatedTemplate);
  };
  addTempReward = () => {
    this.props.actions.addTempReward();
    this.props.actions.updateActiveEditor("newReward");
  };
  updateBackgroundColor = (backgroundColor) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      backgroundColor,
    };

    this.props.actions.updateTemplate(updatedTemplate);
  };

  updateBackgroundImage = (url) => {
    // "updating background image");
    let updatedTemplate = this.props.activeTemplate;
    if (url) {
      if (updatedTemplate.backgroundImage === null) {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: imageView(url),
        };
      } else {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: {
            ...this.props.activeTemplate.backgroundImage,
            url,
          },
        };
      }
    } else {
      updatedTemplate = {
        ...this.props.activeTemplate,
        backgroundImage: null,
      };
    }

    this.props.actions.updateTemplate(updatedTemplate);
  };
  dollarsToDollarCashCreditConversionWarning = () => {
    const {
      dollarsToDollarCashCreditConversion,
      purchaseDollarToPointsConversion,
    } = this.props.activeApp;

    if (dollarsToDollarCashCreditConversion) {
      return (
        <BottomHintText style={{ margin: "0px 20px" }}>
          This means the customer will redeem{" "}
          {(
            (purchaseDollarToPointsConversion || 100) *
            dollarsToDollarCashCreditConversion
          ).toLocaleString()}{" "}
          points for $1.00 cash credit
        </BottomHintText>
      );
    }
  };
  hasReward = () => Object.keys(this.props.rewards).length > 0;

  rewardPassword = () => {
    const { rewardCode, name } = this.props.activeApp;

    const qrCodeName = `${name}_rewardCode_${new Date().toLocaleDateString()}`;

    if (this.hasReward()) {
      return (
        <React.Fragment>
          <H2
            fontSize="25px"
            lineHeight="29px"
            width="290px"
            fontWeight="normal"
            margin="0px"
            className="rewardPassword"
          >
            Reward Password
          </H2>
          <FlexRow height="auto">
            <div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <span className="rewardPassword">
                  Reward Redemption Password (required):
                </span>
                {/* <HintModal
                  modalLeft="2em"
                  position="relative"
                  width="470px"
                  height="auto"
                  margin="auto auto auto 8px"
                >
                  <div
                    style={{
                      fontSize: "0.9em"
                    }}
                  >
                    <p>
                      In order to redeem a reward, you must set a password. To
                      see how this password will be used, read the redemption
                      type hint above.{" "}
                    </p>
                    <p>
                      In case you pick option 2, you can download your password
                      QR to the left.{" "}
                    </p>
                  </div>
                </HintModal> */}
              </div>
              <QRCodeGenerator text={rewardCode} name={qrCodeName} />
            </div>
            <Input
              type="text"
              width="50%"
              fontSize="1em"
              field="Enter Password"
              onChange={this.update("rewardCode")}
              defaultValue={rewardCode}
            />
          </FlexRow>
        </React.Fragment>
      );
    }
  };
  renderPageSettings = () => {
    // if (!this.hasReward()) return null;
    const { activeApp, activeTemplate, activeEditor } = this.props;
    const { croppingAspectRatio } = this.state;
    return (
      <div className={container}>
        <EditBackground
          croppingAspectRatio={croppingAspectRatio}
          update={this.updatePic}
          updateComponent={this.updateComponent}
          pictureCatalogComponent={
            activeTemplate.type === "pictureCatalog"
              ? activeTemplate.components[0]
              : false
          }
          updateBackgroundColor={this.updateBackgroundColor}
          updateBackgroundImage={this.updateBackgroundImage}
          backgroundColor={activeTemplate.backgroundColor}
          backgroundImage={activeTemplate.backgroundImage}
          additionalPageSettings={this.additionalPageSettings}
          appId={activeApp.id}
        />
        <SaveProgress />
      </div>
    );
  };

  renderRewardsRedemptionType = () => {
    // if (!this.hasReward()) return null;
    const {
      activeApp: { rewardRedemptionType },
    } = this.props;
    const isManual = rewardRedemptionType == 1;
    const isCustomerScans = rewardRedemptionType == 2;
    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            width: "345px",
            alignItems: "center",
          }}
        >
          <H2
            fontSize="20px"
            lineHeight="29px"
            className="rewardRedemption"
            fontWeight="normal"
            margin="0px"
          >
            Reward Redemption Type
          </H2>
          {/* <HintModal
            modalLeft="2em"
            position="relative"
            width="470px"
            height="auto"
            margin="auto auto auto 8px"
          >
            <div
              style={{
                fontSize: "0.9em"
              }}
            >
              <p>
                You can choose how to verify reward usage by enforcing
                verification before the reward is redeemed. You may choose:
              </p>
              <br />
              <p>1. None - A customer can redeem reward without any verifications.</p> 
              <p>
                1. Manual Entry - When redeeming a reward, a customer must
                request your staff member to type in the reward you have
                specified above.
              </p>
              <br />
              <p>
                2. Customer Scans QR - When redeeming a reward, a customer must
                scan your unique QR code which can be downloaded and printed
                above in the "reward code" section.
              </p>
              <br />
              <p>
                3. Business Scans Customer QR - When the customer redeems a
                reward, a QR code will pop up on their phone. Using your admin
                panel in the Mobile360 app, scan the customers QR code.
              </p>
            </div>
          </HintModal> */}
        </div>
        <FlexRow width="100%" className="rewardPassword" height="auto">
          {/* <span>
            Select which method customer earn points and use cash credit
          </span> */}
          {/* <SelectOptions
            width="390px"
            containerWidth="300px"
            value={rewardRedemptionType}
            options={redemptionTypeOptions}
            setValue={this.update("rewardRedemptionType")}
          /> */}
          <RadioOptions
            {...this.props}
            // value={redemptionType}
            value={rewardRedemptionType}
            options={redemptionTypeOptions2}
            setValue={this.update("rewardRedemptionType")}
            showPasswordInput={isManual}
            showQRCode={isCustomerScans}
            pageType="reward"
          ></RadioOptions>
        </FlexRow>
      </React.Fragment>
    );
  };

  updatePageName = (pageName) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      pageName,
    };
    this.props.actions.updateTemplate(updatedTemplate);
  };

  render() {
    const {
      activeTemplate: { pageName },
    } = this.props;
    const {
      cashCreditRewardsEnabled,
      dollarsToDollarCashCreditConversion,
      purchaseDollarToPointsConversion,
      minimumCashRequired,
    } = this.props.activeApp;
    const hasNewReward = this.props.rewards.newReward;
    // console.log(dollarsToDollarCashCreditConversion);
    return (
      <div>
        {this.renderPageSettings()}
        <Form marginBottom="3em" marginTop="1em">
          <div style={{ marginBottom: "20px" }}>
            <H1
              fontSize="24px"
              className="heading"
              lineHeight="35px"
              style={{ textAlign: "left", letterSpacing: "2px" }}
            >
              Rewards Settings
            </H1>
          </div>
          {/* <FlexRow>
            <H2 width="290px" margin="inherit">
              Page Title:{" "}
            </H2>
            <Input
              field="Page Title"
              defaultValue={pageName}
              onChange={this.updatePageName}
              type="text"
              height="5%"
              width="67%"
              color="black"
              textColor="black"
            />
          </FlexRow> */}
          <H2
            fontSize="20px"
            lineHeight="29px"
            className="pointsConversion"
            width="290px"
            fontWeight="normal"
            margin="0px"
          >
            Points Conversion
          </H2>
          <FlexRow
            width="100%"
            style={{ height: "auto", justifyContent: "flex-start" }}
          >
            <p
              style={{
                fontSize: "15px",
                margin: "15px 10px 15px 0px",
              }}
            >
              How many points does a customer earn for every $1.00 spent?
            </p>
            <div>
              <SelectOptions
                width="8em"
                value={purchaseDollarToPointsConversion}
                options={pointsConversionArray()}
                setValue={this.update("purchaseDollarToPointsConversion")}
              />
            </div>
          </FlexRow>
          <br />
          <H2
            fontSize="20px"
            lineHeight="29px"
            className="cashCredit"
            width="290px"
            fontWeight="normal"
            margin="0px"
          >
            Cash Credit
          </H2>
          <FlexRow width="100%" style={{ height: "auto" }}>
            <p
              style={{
                fontSize: "15px",
                margin: "15px 0px",
              }}
            >
              Customers are allowed to use points as cash credit towards their
              next purchase
            </p>
            <Input
              type="checkbox"
              onChange={this.update("cashCreditRewardsEnabled")}
              defaultValue={cashCreditRewardsEnabled}
            />
          </FlexRow>
          {!!cashCreditRewardsEnabled && (
            <React.Fragment>
              <FlexRow style={{ height: "auto" }}>
                <div className={columnFlex}>
                  <p
                    style={{
                      fontSize: "15px",
                      margin: "0px 20px",
                    }}
                  >
                    How much should a customer spend to earn $1.00 back in cash
                    credit?
                  </p>
                  {this.dollarsToDollarCashCreditConversionWarning()}
                </div>
                <div
                  style={{
                    width: "12%",
                  }}
                >
                  {/* <Input
                    width="89px"
                    fontSize="1em"
                    marginBottom="10px"
                    field="$00.00"
                    disabled={!cashCreditRewardsEnabled}
                    onChange={this.update(
                      "dollarsToDollarCashCreditConversion"
                    )}
                    defaultValue={dollarsToDollarCashCreditConversion}
                  /> */}

                  <NumberFormat
                    placeholder="$0"
                    thousandSeparator={true}
                    prefix={"$"}
                    decimalScale={0}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    // defaultValue={price ? formatCentsToDollars(price) : null}
                    defaultValue={dollarsToDollarCashCreditConversion}
                    onValueChange={this.update(
                      "dollarsToDollarCashCreditConversion"
                    )}
                    className={inputStyle}
                    disabled={!cashCreditRewardsEnabled}
                  />
                </div>
              </FlexRow>
              <FlexRow style={{ height: "auto" }}>
                <p
                  style={{
                    fontSize: "15px",
                    margin: "0px 20px",
                  }}
                >
                  Minimum cash credit required before redeeming?
                </p>
                <div
                  style={{
                    width: "12%",
                  }}
                >
                  {/* <Input
                    width="89px"
                    fontSize="1em"
                    field="$00.00"
                    marginBottom="10px"
                    disabled={!cashCreditRewardsEnabled}
                    onChange={this.update("minimumCashRequired")}
                    defaultValue={minimumCashRequired}
                  /> */}

                  <NumberFormat
                    placeholder="$0"
                    thousandSeparator={true}
                    prefix={"$"}
                    decimalScale={0}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    // defaultValue={price ? formatCentsToDollars(price) : null}
                    defaultValue={minimumCashRequired}
                    onValueChange={this.update("minimumCashRequired")}
                    className={inputStyle}
                    disabled={!cashCreditRewardsEnabled}
                  />
                </div>
              </FlexRow>
            </React.Fragment>
          )}
          <br />
          {this.renderRewardsRedemptionType()}
          <br />

          <div style={{ textAlign: "center" }}>
            <Button
              onClick={this.addTempReward}
              className="newRewardButton"
              style={{
                marginLeft: " 0px",
                marginBottom: "40px",
                display: "inline-flex",
                alignItems: "center",
                textAlign: "center",
                fontSize: "15px",
                lineHeight: "29px",
                borderRadius: "5.5px",
                backgroundColor: "#89d2d3",
                fontWeight: "bold",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                fontStyle: "normal",
                fontStretch: "normal",
                textTransform: "none",
              }}
            >
              <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
              Create New Reward
            </Button>
          </div>
          <SaveProgress />
        </Form>
      </div>
    );
  }
}

export default withRedux(RewardsSettings);
